import moment from 'moment';
import { BatchAuthorizer } from './batch-authorizer';
const authorizers = {};
export const authorizer = (delay = moment.duration(0, 'seconds'))=>(channel)=>({
            authorize: (socketId, callback)=>{
                var _authorizers_socketId;
                authorizers[socketId] = (_authorizers_socketId = authorizers[socketId]) !== null && _authorizers_socketId !== void 0 ? _authorizers_socketId : new BatchAuthorizer(socketId, delay);
                authorizers[socketId].add(channel.name, callback);
            }
        });
